<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('CASES.RUNNING_CASES.SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="runningProcesses"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="id"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn
          small
          class="mr-2"
          color="error"
          @click="deleteInstance(row.item)"
        >
          {{ $t('GENERAL.BTNS.DELETE') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="deleteDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteText }}</div>
            <div>{{ deleteText2 }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDelete({instanceId})"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  export default {
    name: 'runningcases',
    computed: {
      ...mapGetters(['runningProcesses'])
    },
    data: function() {
      return {
        loading: false,
        deleteDialog: false,
        deleteTitle: '',
        deleteText: '',
        deleteText2: '',
        instanceId: '',
        search: '',
        sortBy: '',
        sortDesc: false,
        theCaseId: 0,
        theProcessName: '',
        headers: [
          { text: this.$t('CASES.FIELDS.CASE_ID'),
            align: 'start',
            sortable: true,
            value: 'caseId' 
          },
          { text: this.$t('CASES.FIELDS.PROCESS_NAME'), sortable: true, value: 'processName' },
          { text: this.$t('CASES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ]
      }
    },
    created() {
      this.refreshProcesses();
    },
    methods: {
      refreshProcesses() {
        this.loading = true;
        this.$store.dispatch('getProcessInstances').then( () => {
          this.loading = false;
          // Apply sort field and order
          let field = this.$store.state.unningCasesSortField;
          let sort = this.$store.state.runningCasesSortOrder;
          if(field == null) {
            this.sortBy = 'caseId';
            this.sortDesc = true;
          }else if (sort == 'none') {
            this.sortBy = '';
            this.sortDesc = false;
          }else {
            this.sortBy = field;

            if(sort == 'descending') {
              this.sortDesc = true;
            }else {
              this.sortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.headers.length; i++) {
              if(column == ref.headers[i].text) {
                ref.$store.commit('setRunningCasesSortField', ref.headers[i].value);
                ref.$store.commit('setRunningCasesSortOrder', order);
              }
            }
          });
        });
      },
      deleteInstance(item) {
        this.deleteTitle = this.$t('CASES.RUNNING_CASES.DELETE_TITLE');
        this.deleteText = this.$t('CASES.RUNNING_CASES.DELETE_TEXT_1') + ' ' + item.caseId;
        this.deleteText2 = this.$t('CASES.RUNNING_CASES.DELETE_TEXT_2') + ' ' + item.id;
        this.instanceId = item.id;
        this.theCaseId = item.caseId;
        this.theProcessName = item.processName;
        this.deleteDialog = true;
      },
      confirmDelete(item) {
        this.deleteDialog = false;
        let payload = {
          'id': item.instanceId
        }
        this.$store.dispatch('deleteProcessInstance', payload).then( () => {
          this.updateLog('Case', 'Deleted', this.theCaseId, this.theProcessName, 'Case ' + this.theCaseId + ' deleted.');
          this.refreshProcesses();
        });
      },
      updateLog(cat, op, caseId, process, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        if(caseId == null) {
          caseId = 0;
        }

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': caseId,
          'processName': process,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    },
  }
</script>
